import React from 'react'
import CustomerList from './CustomerList'

export default function List(props) {
    console.log(props)
    return (
        <div class="col-lg-12 list-scroll">
        <div class="table-responsive-sm  card card-body">
        <table className="table tCustom table-text">
              <thead >
                  <tr className='list-top'>
                      <th className=''>Customer Code</th>
                      <th className=''>Customer Name</th>
                      <th className=''>Address</th>
                      <th className=''>Category</th>
                      <th className=''>Incoterms</th>
                      <th></th>
                      <th></th>
                    </tr>
              </thead>
              <tbody>
                  {(localStorage.getItem('List_Customers') == 3 || localStorage.getItem('List_Customers') == 1) &&
                    <>
                        {props.data.map((list,k)=>(
                            <CustomerList data={list}  edit={props.edit} disable={props.disable}/>
                        ))}
                    </>
                  }
              </tbody>
      </table>
      </div>
      </div>
    )
}
